import {
  Button,
  DatePicker,
  Divider,
  Input,
  message,
  Select,
  Space,
} from "antd";
import { ConditionalRenderer } from "components";
import styles from "./styles.module.scss";
import dayjs from "dayjs";
import { AccordianDropdownArrow, CalenderIcon, DropdownSuffix } from "icons";
import {
  childKeys,
  dropdownAddItemEndPoints,
  dropdownAddItemError,
  dropdownAddItemKeyNameForPayload,
} from "pages/cases-detail/constants";
import { useEffect, useRef, useState } from "react";
import { PrefixInsideInput } from "../prefixInsideInput";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { PlusOutlined } from "@ant-design/icons";
import { UseLazyApiCallV2 } from "hooks";
import { useRecoilState } from "recoil";
import { caseStatus } from "store/atom";
import moment from "moment";

export const ParentInputField = ({
  totalFormData,
  setTotalFormData,
  item,
  handleUpdateCase,
  refetchFieldHistory,
  autoFocus = false,
}) => {
  const { translator } = useLanguageTranslator();
  const { refetchList } = item;
  const [addItemIndropdown, setAddItemInDropdown] = useState();
  const [caseStatusOpenOrClosed, setCaseStatusOpenOrClosed] =
    useRecoilState(caseStatus);

  const [
    addNewItemInDrodownDB,
    {
      data: addNewItemInDrodownDBData,
      isLoading: addNewItemInDrodownDBLoading,
      error: addNewItemInDrodownDBError,
    },
  ] = UseLazyApiCallV2({
    url: dropdownAddItemEndPoints[item?.dropdownType],
    method: "POST",
  });

  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  function handleChangeInput(event) {
    const { name, value } = event.target;

    setTotalFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
  function handleChangeDate(date, dateString) {
    setTotalFormData((prev) => ({
      ...prev,
      [item.key]: dateString,
    }));

    // handleUpdateCase(item.key, dateString);
    // refetchFieldHistory();
  }

  function getFormateDate(date) {
    if (date && item.type === "date") {
      if (date?.includes(".")) {
        const format = date?.replace(/\./g, "-");
        return dayjs(format, ["DD-MM-YYYY", "DD-MM-YY"], true);
      } else if (date?.includes("-")) {
        return dayjs(totalFormData[item.key]);
      }
    }
  }
  function handleSelect(e, data) {
    setTotalFormData((prev) => ({
      ...prev,
      [item.key]: data?.label,
    }));

    // handleUpdateCase(item.key, data?.label);
  }
  function onChangeAddItem(event) {
    const { value } = event.target;
    setAddItemInDropdown(value);
  }
  async function onClickAddDropdownItem({ name, value }) {
    if (!value)
      return message.error(
        translator(
          `caseDetail.form.${dropdownAddItemError[item?.dropdownType]}`,
        ),
      );
    const params = {
      [dropdownAddItemKeyNameForPayload[item.dropdownType]]: value,
    };
    try {
      const res = await addNewItemInDrodownDB({ params });
      if (res?.status === "SUCCESS") {
        message.success(translator("addedSuccess"));
        refetchList();
        setAddItemInDropdown("");
      }
    } catch (error) {
      message.error(translator("somethingWentWrong"));
    }
  }

  const readOnlyValueOfParent = childKeys[item.key]
    ?.map((childItem) => totalFormData[childItem.key])
    .filter((item) => !!item);

  const FinalReadOnlyValueOfParent =
    readOnlyValueOfParent?.length > 1
      ? readOnlyValueOfParent?.join(", ")
      : readOnlyValueOfParent;

  return (
    <>
      <ConditionalRenderer
        condition={item.type === "text" || item?.type === "number"}
      >
        <Input
          disabled={caseStatusOpenOrClosed === "closed"}
          prefix={<PrefixInsideInput item={item} />}
          type="text"
          value={totalFormData[item.key]}
          onChange={handleChangeInput}
          name={item.key}
          style={{ margin: "15px 0px", height: "40px" }}
          readOnly={item?.isParent}
          maxLength={40}
          // ref={inputRef}
          className={`${item?.isParent ? styles.readOnly : ""}`}
        />
      </ConditionalRenderer>
      <ConditionalRenderer condition={item.type === "date"}>
        <div className={styles.datePickerWrapper}>
          <div
            className={styles.dropdownWrapper}
            style={{
              position: "relative",
              border: autoFocus ? "1px solid #cd2a3f" : "1px solid #d9d9d9",
              borderRadius: "6px",
              display: "flex",
            }}
            ref={inputRef}
          >
            <PrefixInsideInput item={item} />
            <DatePicker
              maxDate={item?.allow === "tillToday" ? dayjs() : undefined}
              inputReadOnly
              placeholder={"DD.MM.YYYY"}
              allowClear
              format="DD.MM.YYYY"
              value={
                totalFormData[item.key] &&
                getFormateDate(totalFormData[item.key])
              }
              onChange={handleChangeDate}
              name={item.key}
              style={{ width: "100%" }}
              suffixIcon={<CalenderIcon />}
            />
          </div>
        </div>
      </ConditionalRenderer>
      <ConditionalRenderer condition={item?.type === "dropdown"}>
        <div
          style={{
            position: "relative",
            width: "100%",
            border: autoFocus ? "1px solid #cd2a3f" : "1px solid #d9d9d9",
            borderRadius: "6px",
            display: "flex",
          }}
          className={styles.select}
          ref={inputRef}
        >
          <PrefixInsideInput item={item} />
          <Select
            showSearch
            allowClear
            filterOption={(
              input,
              option, // 👈 filter logic
            ) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            value={totalFormData[item.key]}
            style={{
              width: "100%",
              height: "40px",
            }}
            suffixIcon={<DropdownSuffix />}
            placeholder=""
            onChange={handleSelect}
            options={item?.dropdownList}
            dropdownRender={
              refetchList
                ? (menu) => (
                    <>
                      {menu}
                      <Divider style={{ margin: "8px 0" }} />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Input
                          placeholder={translator("enterItem")}
                          // ref={inputRef}
                          name={item.dropdownType}
                          value={addItemIndropdown}
                          onChange={onChangeAddItem}
                          onKeyDown={(e) => e.stopPropagation()}
                          className={styles.addItemInput}
                          maxLength={40}
                        />
                        <Button
                          className={styles.addItemInputBtn}
                          type="text"
                          icon={<PlusOutlined />}
                          style={{ fontWeight: "bold" }}
                          onClick={() =>
                            onClickAddDropdownItem({
                              name: item?.dropdownType,
                              value: addItemIndropdown,
                            })
                          }
                        >
                          {translator("addItem")}
                        </Button>
                      </div>
                    </>
                  )
                : undefined
            }
          />
        </div>
      </ConditionalRenderer>
    </>
  );
};
